import React from "react"
import { useRouter } from "next/router"
import { getIsSsrMobile } from "src/utils/getIsSsrMobile"

import MobileDirectPayment from "../../../components/pages/directPayment/mobile"
import DesktopDirectPayment from "../../../components/pages/directPayment/desktop"

// Hooks
import { useIsMobile } from "src/hooks/useIsMobile"

// -------------------------------------------|| CONTACT US - PAGES ||-------------------------------------------------------

const PayInstallment = () => {
  const { query } = useRouter()
  const url = query.id
  const isMobile = useIsMobile()

  return isMobile ? <MobileDirectPayment paymentUrl={url} /> : <DesktopDirectPayment paymentUrl={url} />
}

export default PayInstallment

export async function getServerSideProps(context = GetServerSidePropsContext) {
  return {
    props: {
      isSsrMobile: getIsSsrMobile(context)
    }
  }
}
